import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Button, Image, Row, Col, Modal, Form } from "react-bootstrap";
import { filteredCreateNewKey, filteredIndex, } from "../../../../utils/ManageArray";
import CardDisplayComponent from "../../../../components/CardDisplayComponent";
import { CameraIcon, CloseIcon, ImageFileIcon, MinusIcon, ViewImageIcon } from "../../../../data/iconImage";
import Table from "../../../../components/Table";
import { addEditServiceRequest, getServiceRequest } from "../../../../commons/ServiceRequest";
import { useAlert } from "../../../../context/AlertContext";
import TechCheckinService from "../../../../services/techcheckin.service";
import { formatDate, formatTime } from "../../../../commons/FormatValue";
import { formatInputDate, toFormatISO } from "../../../../utils/Time";
import InputSearch from "../../../../components/InputSearhComponent";
import TableLimitPagination from "../../../../components/TableLimitPagination";
import { getQueryString } from "../../../../utils/Query";
import { MediaPreviewer } from "../../../../components/MediaUploader";
import PropTypes from "prop-types";
import FileUploadsService from "../../../../services/fileupload.service";
import moment from "moment";

export default function CheckIn() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [currentDate, setCurrentDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [allCountData, setAllCountData] = useState();
  const [dataShowImage, setDataShowImage] = useState(null);

  const columns = [
    {
      name: "ลำดับ",
      selector: (row) => row.rowIndex,
      sortable: true,
      width: "110px"
    },
    {
      name: "เลขที่ใบสั่งงาน",
      selector: (row) => row.Seq_No,
      readOnly: true,
      width: "180px"
    },
    {
      name: "รหัสลูกค้า/สาขา",
      selector: (row) => row.Cus_Code,
      readOnly: true,
      width: "180px"
    },
    {
      name: "เลขที่สาขา",
      selector: (row) => row.Branch_No,
      readOnly: true,
      width: "180px"
    },
    {
      name: "ชื่อลูกค้า/สาขา",
      selector: (row) => row.Cus_Name,
      readOnly: true,
      width: "240px"
    },
    {
      name: "วันที่เข้างาน",
      selector: (row) => row.Job_Actual_Date,
      readOnly: true,
      width: "150px"
    },
    {
      name: "ผู้ติดต่อ",
      selector: (row) => row.Tech_Name,
      readOnly: true,
      width: "180px"
    },
    {
      name: "เบอร์ติดต่อ",
      selector: (row) => row.Tech_Tel,
      readOnly: true,
      width: "150px"
    },
    {
      name: "วันเวลาโทรนัดหมาย",
      selector: (row) => displayDateTime(row.Appointment_Tel_Date),
      readOnly: true,
      width: "200px"
    },
    {
      name: "วันเวลานัดหมาย",
      selector: (row) => displayDateTime(row.Appointment_Date),
      readOnly: true,
      width: "200px"
    },
    {
      name: "วันเวลาเข้างานจริง",
      selector: (row) => displayDateTime(row.Work_Actual_Date),
      readOnly: true,
      width: "200px"
    },
    {
      name: "ถ่ายรูป",
      // type:,
      selector: (row) => (
        <AddPhoto
          // button={{ name: "เพิ่มรูปภาพ" }}
          index={row.rowIndex}
          accept="image/png, image/jpeg, image/jpg"
        />
      ),
    },
    {
      name: "รูปภาพ",
      selector: (row) => (
        !!row.Files.length &&
        <div className="d-flex justify-content-center align-items-center ">
          <Image
            style={{ cursor: "pointer" }}
            className="ps-1"
            src={ViewImageIcon}
            alt="Image Icon"
            onClick={() => {
              // setDataShowImage(row.rowIndex)
              // if (dataShowImage !== row.rowIndex) setObjectURL()

              const files = tableData[row.rowIndex - 1]?.Files

              if (files?.length && (files[0]?.name)) {
                setObjectURL()
                setDataShowImage(files)
              } else {
                GetURLImage(files)
              }
            }}
          />
          <Image
            style={{ cursor: "pointer" }}
            className="px-2"
            src={MinusIcon}
            alt="Delete Icon"
            onClick={() => removeImage(row.rowIndex - 1)}
          />
        </div>
      ),
    }
  ];
  function displayDateTime(value) {
    return formatDate(value) + " " + formatTime(value) + " น."
  }
  function removeImage(rowIndex) {
    const clone = [...tableData]
    tableData[rowIndex].Files.forEach(async (file) => {
      if (file?.file_path) {
        await FileUploadsService.deleteFileUploads(destination, file.file_path)
        await TechCheckinService.editTechCheckin(tableData[rowIndex].Id, {
          "file_path": "",
          "file_type": ""
        })
      }
    })
    clone[rowIndex].Files = []
    setTableData(clone)
  }

  const searchInput = [
    {
      name: "sup_team",
      label: "ชื่อทีม/หัวหน้าช่าง",
      classNames: { label: "mb-3" },
      type: "text",
      value: "",
      disabled: true,
      size: 3
    },
    {
      name: "sup_team",
      label: "ช่างผู้ปฏิบัติงาน",
      classNames: { label: "mb-3" },
      type: "text",
      value: "",
      disabled: true,
      size: 3
    },
    {
      name: "start",
      label: "วันที่นัดหมายระหว่างวันที่",
      classNames: { label: "mb-3" },
      type: "date",
      size: 3,
    },
    {
      name: "end",
      label: "ถึงวันที่",
      classNames: { label: "mb-3" },
      type: "date",
      size: 3,
      min: 'start'
    }
  ];

  const [querySearch, setQuerySearch] = useState()

  const fetchData = (search) => {
    const page = search?.page || currentPage
    const limit = search?.limit || rowsPerPage
    const q = getQueryString({
      ...querySearch,
      page: page, limit: limit, ...search,
      start: toFormatISO(search.start),
      end: toFormatISO(search?.end)
    })
    setCurrentPage(page)
    setRowsPerPage(limit)
    setQuerySearch(q)

    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechCheckinService.getAllTechCheckin(q),
      callback: (res) => { pSetData(res.data); setData(res); setAllCountData(res.allCount) }
    });
  }
  const pSetData = (vData) => {
    const newArray = vData?.map((items) => ({
      Id: items.id,
      Seq_No: items.TechScheduleCus.TechnicianPlans.SeqOthersJob?.Seq_Oth_No ||
        items.TechScheduleCus.TechnicianPlans.SeqPmJob?.Seq_Pm_No ||
        items.TechScheduleCus.TechnicianPlans.SeqRepairJob?.Seq_Serv_No ||
        items.TechScheduleCus.TechnicianPlans.SeqInstallJob?.Seq_Inst_No,
      Cus_Code: items.TechScheduleCus.TechnicianPlans?.SeqOthersJob?.InformOtherJob.Customer.Cus_Code,
      Cus_Name: items.TechScheduleCus.TechnicianPlans?.SeqOthersJob?.InformOtherJob.Customer.Cus_Name,
      Branch_No: items.TechScheduleCus.TechnicianPlans?.SeqOthersJob?.InformOtherJob.Customer.Cus_NumBranch,
      Job_Actual_Date: formatInputDate(items.TechScheduleCus.TechnicianPlans?.job_actual_date, "Local").date,
      Tech_Name: items.TechScheduleCus.TechnicianPlans?.tech_mas_name,
      Tech_Tel: items.TechScheduleCus.TechnicianPlans?.tech_mas_tel,
      Appointment_Date: items.TechScheduleCus.appointment_date,
      Appointment_Tel_Date: items.TechScheduleCus.appointment_tel_date,
      Work_Actual_Date: items.TechScheduleCus.work_actual_date,
      Files: !items.file_path ? []
        : [{
          "file_path": items.file_path,
          "file_type": items.type,
        }]
    }));
    setTableData(newArray || [])
  };


  const type = "Image"
  const destination = "check_in/Image"
  const UploadFile = (file, Id) => {
    // console.log(file.name, file)
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: FileUploadsService.createFileUploads(destination, [file]),
      callback: async ({ files }) => {
        // InformRepairFilesService.createInformRepairFiles(InformFiles) //
        await TechCheckinService.editTechCheckin(Id, {
          "file_path": files[0],
          "file_type": file.type
        })
        // navigate("/service_work/acceptance/checkin")
      },
      // navigated: (navi) =>
      //   navi && navigatePage === "Media" && commonNavigatePage(inform_repair_id)
    });
  };
  const AddPhoto = ({ accept, index }) => {
    const fileInputMedia = useRef(null);
    const { showAlert } = useAlert();

    const clone = [...tableData]
    const row = clone[index - 1]
    const handleFileChange = async (e) => {
      const files = Array.from(e.target.files);
      e.target.value = null;

      if (files.find(({ size }) => size > 1024 * 1024 * 25)) {
        return showAlert({
          error: "คำเตือน",
          message: "ขนาดไฟล์ใหญ่เกินไป กรุณาเลือกไฟล์ที่มีขนาดไม่เกิน 25 MB",
          type: "warning"
        });
      }


      const dataFile = files[0] //files.filter(file => row.Files?.some(image => image?.name === file.name) || file)
      row.Files = [...row.Files, dataFile]
      setTableData(clone)
      UploadFile(dataFile, row.Id)
      return
      // setUploadFile((prev) => ({
      //   ...prev,
      //   [type]:
      //     files.length > 0
      //       ? [
      //         ...prev[type],
      //         ...files.filter(
      //           (file) =>
      //             !uploadFile?.[type].some(
      //               (image) => image.name === file.name
      //             )
      //         )
      //       ]
      //       : uploadFile?.[type].filter((img) =>
      //         data.Media[type].some(
      //           (media) => img.name === media.File_Path
      //         )
      //       )
      // }))
    };

    return (
      <>
        <Button
          variant="light"
          className={`p-2 ps-3 my-1 d-flex justify-content-center align-items-center rounded-circle 
          ${row.Files?.length && "bg-transparent border-0"}`}
          onClick={() => fileInputMedia.current.click()}
          disabled={row.Files?.length}
        >

          <Image className="me-2" src={CameraIcon} alt="Upload Icon" />
        </Button>

        <Form.Control
          // multiple
          type="file"
          accept={accept}
          className="d-none"
          ref={fileInputMedia}
          onChange={handleFileChange}
        />
      </>
    );
  }
  AddPhoto.propTypes = {
    accept: PropTypes.string,
    index: PropTypes.number,
  };
  const [objectURL, setObjectURL] = useState()
  function GetURLImage(files) {
    let objectURL
    let fileName = files?.length && (files[0]?.file_path)

    getServiceRequest({
      showAlert,
      setLoading: () => { },
      serviceRequest: FileUploadsService.getFileUploads(destination, fileName),
      callback: (file) => {

        setObjectURL([URL.createObjectURL(file)])
        // console.log('file',file)
        if (file) setDataShowImage(files)
      }
    });
  }
  const ShowPhotoModal = () => {
    // const select = tableData[dataShowImage - 1]?.Files
    // let showImageFromPath = select?.length && select[0]?.file_path

    // if (showImageFromPath && !objectURL?.length) {
    //   GetURLImage(showImageFromPath)
    // }

    return (
      <Modal show={dataShowImage} centered>
        <div className="justify-content-end d-flex p-2">
          <Image
            className="px-2"
            src={CloseIcon}
            alt="Close Icon"
            onClick={() => setDataShowImage(null)}
          />
        </div>
        <div style={{ margin: "auto", padding: "1em", maxHeight: "80vh" }}>
          {objectURL?.map((url, ind) => (
            <Col sm={1}
              key={ind}
              className="w-auto me-2 pe-0 position-relative"
              style={{ height: "300px" }}
            >
              <Image
                className="h-100"
                src={url}
                alt={ind}
              />
            </Col>
          ))}
          <MediaPreviewer
            mediaType={type}
            loading={loading}
            filePreview={dataShowImage?.filter(file => file.name)}
          />
        </div>
      </Modal>
    )
  }
  function setDefaultPage() {
    setTableData([])
    setCurrentPage(1)
  }

  return (
    <>
      <CardDisplayComponent
        header={{ title: { text: "ข้อมูลการเช็คอิน" } }}
        cardClassName="text-center"
        body={{
          element: (
            <>

              <InputSearch
                data={data}
                showActionButtons={false}
                field={searchInput}
                searchCallback={search => search ? fetchData(search) : setDefaultPage()}
              />
            </>
          )
        }}
      />

      <Card className="m-1 mb-4 p-4 border-0">
        <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
          <Card.Title className="mb-0 fs-2 text-dark">
            รายละเอียดการเช็คอิน
          </Card.Title>
        </Card.Header>

        <Card.Body>
          <Table
            data={tableData}
            column={columns}
            pending={loading}
            searchFilter={tableData}
          />
          <ShowPhotoModal />

          <TableLimitPagination
            data={tableData}
            paginationProps={{
              rowsPerPage: rowsPerPage,
              currentPage: currentPage,
              rowCount: allCountData,
              onChangeRowsPerPage: num => fetchData({ limit: num, page: 1 }),
              onChangePage: page => fetchData({ page: page })
            }}
          />
        </Card.Body>

        <Row className="justify-content-end p-3">
          <Col className="col-auto">
            <Button
              variant="outline-secondary"
              className="px-4 py-2 text-dark rounded-pill"
              onClick={() =>
                navigate("/service_work/acceptance", {
                  state: { name: "CheckJobDetails" }
                })
              }
            >
              ย้อนกลับ
            </Button>
          </Col>
        </Row>
      </Card>
    </>
  );
}
